import useSecuredApiService from './useSecuredApiService'

const useManufacturerService = () => {
  const { getApiData, postApiData, getApiDataWithParams, putApiData, deleteApiData } =
    useSecuredApiService()

  const getPaged = async (params) => {
    return await getApiDataWithParams('/Manufacturer/getPaged', params)
  }

  const getById = async (id) => {
    return getApiData('/Manufacturer/GetById?id=' + id)
  }

  const getWithAddressById = async (id) => {
    return getApiData('/Manufacturer/getWithAddressById?id=' + id)
  }

  const getAll = async () => {
    return getApiData('/Manufacturer/getAll')
  }

  const create = async (data) => {
    return postApiData('/Manufacturer/Create', data)
  }

  const update = async (id, data) => {
    return putApiData('/Manufacturer/Edit?id=' + id, data)
  }
  const remove = async (id) => {
    return deleteApiData('/Manufacturer/Delete?id=' + id)
  }
  return {
    getPaged,
    getById,
    getWithAddressById,
    getAll,
    create,
    update,
    remove,
  }
}
export default useManufacturerService
